import React from 'react';
import { Dashboard } from '@components/common/Dashboard';
import { PageLayout } from '@components/common/PageLayout';
import { useDashboardPermissions } from '@components/utils/DashboardPermissions/useDashboardPermissions';
import { Button, HeadContent, List, Pagination, Table, ToolbarButton, useMediaQueryContext, } from '@fourthwall/components';
import { PlusIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import { useSeriesContext } from './hooks/useSeriesContext';
import { SeriesProvider } from './providers/SeriesProvider';
const SeriesComponent = () => {
    const { hasPermission } = useDashboardPermissions();
    const media = useMediaQueryContext();
    const { table, list, pageCount, currentPage, setCurrentPage } = useSeriesContext();
    const getToolbarContent = () => {
        if (!hasPermission('memberships.video.create'))
            return null;
        if (media.tablet) {
            return (React.createElement(Button, { size: "small", label: "Add new video series", appearance: "primary", to: routing.memberships.series.create }));
        }
        return (React.createElement(ToolbarButton, { label: "Add new video series", icon: PlusIcon, to: routing.memberships.series.create }));
    };
    return (React.createElement(PageLayout, { size: "large" },
        React.createElement(Dashboard.Section, { name: "Video series", bottomMargin: "medium", toolbarContent: getToolbarContent() },
            React.createElement(HeadContent, { title: "Video series" }),
            React.createElement(Dashboard.Section.Item, null, media.tablet ? React.createElement(Table, { ...table }) : React.createElement(List, { ...list })),
            pageCount !== 1 && (React.createElement(Dashboard.Section.Item, null,
                React.createElement(Pagination, { pageCount: pageCount, currentPage: currentPage, onChange: setCurrentPage }))))));
};
export const Series = () => (React.createElement(SeriesProvider, null,
    React.createElement(SeriesComponent, null)));
